// Copyright (c) StrangeBee 2024

import { Route as RouteAccount } from './Details';

export const Routes = [RouteAccount];
